import { isServiceActive } from '@/utils/isServiceActive';

import { CMSSection } from '@/cms/CMSSection';
import { Box } from '@/components/Box';
import { Heading } from '@/components/Cms/Heading/Heading';
import type {
  ContentfulHeadingFragment,
  ContentfulServiceFragment,
  ContentfulServicesFragment,
} from '@/graphql/contentful/api';
import { generateDataTestId } from '@/lib/tests';
import { useConfigProvider } from '@/providers/ConfigProvider';

import { Service } from './components';

import * as S from './Services.styles';

export type ServicesProps = ContentfulServicesFragment;

export const Services = ({ headline, servicesCollection }: ServicesProps) => {
  const { moduleActivations, warrantyExtensionCampaignEnable } =
    useConfigProvider();

  return (
    <CMSSection
      data-test-id='ServicesSection'
      withMargin={false}
      {...generateDataTestId('services', 'section')}
    >
      <Box>
        <S.HeaderWrapper>
          <Heading
            Heading={headline as ContentfulHeadingFragment}
            data-test-id='BoutiquesListHeading'
            sizeDesktop={40}
            sizeMobile={34}
          ></Heading>
        </S.HeaderWrapper>
        <S.Services>
          {servicesCollection?.items
            .filter((item): item is ContentfulServiceFragment => item !== null)
            .filter((item) => {
              if (item.id === 'WARRANTY') {
                return warrantyExtensionCampaignEnable;
              }
              return isServiceActive(moduleActivations, item.id);
            })
            .map((item, index) => {
              const props = { ...item } as ContentfulServiceFragment;
              return (
                <Service
                  key={props?.sys.id}
                  {...props}
                  data-test-id={`Service-${index}`}
                />
              );
            })}
        </S.Services>
      </Box>
    </CMSSection>
  );
};

Services.displayName = 'Services';
